module.exports = __webpack_public_path__ + "assets/addComment.288d7317.svg";